<div class="file-library-wrapper">
  <div class="files-header">
    <button class="file-library-buttons" (click)="changeSelection()">
      {{ isSelectedAll ? 'Unselect All' : 'Select All' }}
    </button>
  </div>
  <div class="files-content">
    @if (files.length) {
      @for (file of files; track file) {
        <div class="file-item">
          <mat-checkbox [(ngModel)]="file.isSelected" />
          @if (file.fileName) {
            <span [matTooltip]="file.fileName" [ngClass]="{ 'is-selected': file.isSelected }">
              {{ file.fileName | truncate: 16 }}
            </span>
          }
        </div>
      }
    } @else {
      <p class="no-files">No files in this Room</p>
    }
  </div>
  <div class="files-footer">
    <button class="file-library-buttons" [disabled]="isLoading" (click)="startDownload()">
      @if (isLoading) {
        <span class="flex justify-center">
          <app-loading />
        </span>
      } @else {
        Download Selection
      }
    </button>
  </div>
</div>
